export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['Account']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Account Information',
        to: '/functions/AccountInfo',
        icon: 'cil-pencil'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Payment Information',
        to: '/functions/paymentinfo',
        icon: 'cil-credit-card'
      },
      
      {
        _name: 'CSidebarNavItem',
        name: 'Sites',
        to: '/functions/sites',
        icon: 'cil-building'
      },
     
      
      
    ]
  }
]